function convertStatusInvite(status: string) {
  const AllStatus: any = {
    SEND: "Enviado",
    EXPIRED: "Expirado",
    ACCEPTED: "Aceito",
  };

  return AllStatus[status];
}

function profileType(profile: string) {
  const AllStatus: any = {
    MEN: "Homem",
    WOMAN: "Mulher",
    COUPLEMxW: "Casal (HxM)",
    COUPLEMxM: "Casal (HxH)",
    COUPLEWxW: "Casal (MxM)",
  };

  return AllStatus[profile] || profile;
}

function convertMaritalTypes(type: string) {
  const MaritalTypes: any = {
    SINGLE: "Solteiro",
    MARRIED: "Casado",
    FALLING_IN_LOVE: "Namorando",
    STABLE_UNION: "União Estável",
    DIVORCED: "Divorciado",
    WIDOWER: "Viúvo",
  };

  return MaritalTypes[type];
}

function formatDate(timestamp: string | Date, showTime = false) {
  if (!timestamp) return "--/--/----";
  const date = new Date(timestamp);

  date.setHours(date.getHours() + 3);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const year = date.getFullYear();

  const formattedDate = `${day}/${month}/${year}`;

  if (showTime) {
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${formattedDate} ${hours}:${minutes}:${seconds}`;
  }

  return formattedDate;
}

function applyPhoneMask(phone: string) {
  // Remove todos os caracteres que não são dígitos
  phone = phone.replace(/\D/g, "");

  // Aplica a máscara apropriada com base no comprimento do número
  if (phone.length === 11) {
    // Formato para números com 11 dígitos: (00) 00000-0000
    phone = phone.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
  } else if (phone.length === 10) {
    // Formato para números com 10 dígitos: (00) 0000-0000
    phone = phone.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
  }

  return phone;
}

function hasPermission(user_type: string) {
  if (user_type === "SUPERADMIN") {
    return true;
  }
  if (user_type === "ADMIN") {
    return true;
  }
  return false;
}

const NAME_PARTICLES = new Set(["de", "da", "do", "das", "dos", "e"]);

/**
 * Remove espaços/caracteres invisíveis e normaliza o token.
 */
function cleanNameToken(part: string): string {
  return String(part)
    .normalize("NFC")
    .replace(/[\u200B-\u200D\uFEFF]/g, "")
    .trim();
}

/**
 * Capitaliza a primeira letra (Unicode) e deixa o restante minúsculo.
 * Partículas (de/da/do...) ficam em minúsculo, exceto se forem a 1ª palavra.
 */
function capitalizeNamePart(part: string, isFirstWord: boolean): string {
  const cleaned = cleanNameToken(part);
  if (!cleaned) return "";

  const lower = cleaned.toLowerCase();

  if (!isFirstWord && NAME_PARTICLES.has(lower)) {
    return lower;
  }

  const match = lower.match(/^([^\p{L}]*)(\p{L})(.*)$/u);
  if (!match) {
    return lower.charAt(0).toUpperCase() + lower.slice(1);
  }

  return `${match[1]}${match[2].toUpperCase()}${match[3]}`;
}

/**
 * Standardize a name string by uppercasing the first letter of each word and lowercasing the rest.
 * Removes extra spaces and empty / undefined tokens from the split.
 * Particles (de, da, do...) stay lowercase unless they are the first word.
 * @param name The name to standardize.
 * @returns The standardized name.
 */
function standardizeName(name: string) {
  if (!name) return "";

  return name
    .trim()
    .split(/\s+/)
    .map(cleanNameToken)
    .filter(
      (part) =>
        part != null &&
        part !== "" &&
        part.toLowerCase() !== "undefined"
    )
    .map((part, index) => capitalizeNamePart(part, index === 0))
    .filter(Boolean)
    .join(" ");
}

export {
  convertStatusInvite,
  convertMaritalTypes,
  formatDate,
  applyPhoneMask,
  profileType,
  hasPermission,
  standardizeName,
};
